"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodeAppFileContentAction = void 0;
const path_1 = require("path");
const stream_utils_1 = require("../../stream-utils");
const nodeAppFiles = ["package.json", "package-lock.json", "yarn.lock"];
const deletedAppFiles = nodeAppFiles.map((file) => ".wh." + file);
function filePathMatches(filePath) {
    const fileName = (0, path_1.basename)(filePath);
    return nodeAppFiles.includes(fileName) || deletedAppFiles.includes(fileName);
}
exports.getNodeAppFileContentAction = {
    actionName: "node-app-files",
    filePathMatches,
    callback: stream_utils_1.streamToString,
};
//# sourceMappingURL=static.js.map